/** @type {import('tailwindcss').Config} */
module.exports = {
  mode: 'jit',
  darkMode: ['class'],
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
  theme: {
    container: {
      center: true,
      padding: '2rem',
      screens: {
        '2xl': '1400px',
      },
    },
    extend: {
      typography: {
        DEFAULT: {
          css: {
            p: {
              fontSize: '14px',
              ':where(.prose > :first-child):not(:where([class~="not-prose"] *))':
                {
                  marginTop: 0,
                },
              ':not(:where([class~="not-prose"] *))': {
                marginTop: '12px',
                marginBottom: '12px',
              },
            },
          },
        },
      },
      dropShadow: {
        card: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        browseCard: '0px 0px 10px rgba(0, 0, 0, 0.10)',
      },
      boxShadow: {
        card: '0px 2px 8px 0px rgba(0, 0, 0, 0.10)',
      },
      // TODO: check - for android devices to prevent the bottom content from cutting off from the view
      flex: {
        '9-1-0': '0.9 1 0%',
      },
      zIndex: {
        60: '60',
        70: '70',
        80: '80',
        90: '90',
        100: '100',
        1000: '1000',
        2000: '2000',
        3000: '3000',
      },
      colors: {
        primary: {
          // DEFAULT: '#33CCCC',
          ORIGINAL: '#33CCCC',
          DEFAULT: 'rgb(var(--color-primary))',
          // 'light-1': 'rgba(51, 204, 204, 0.1)',
          // 'light-1': 'rgba(var(--color-primary), 0.1)',
          'original-light-1': 'rgba(51, 204, 204, 0.1)',
          'light-1': 'rgb(var(--color-primary) / 0.1)',
        },
        secondary: {
          // DEFAULT: '#ECA400',
          ORIGINAL: '#ECA400',
          DEFAULT: 'rgb(var(--color-secondary))',
          // 'light-1': 'rgba(236, 164, 0, 0.1)',
          'original-light-1': 'rgba(236, 164, 0, 0.1)',
          'light-1': 'rgb(var(--color-secondary) / 0.1)',
        },
        tertiary: {
          DEFAULT: 'rgb(188, 80, 144)',
          'light-1': 'rgba(188, 80, 144, 0.1)',
        },
        'body-background': {
          DEFAULT: '#F0F2F5',
        },
        error: {
          DEFAULT: '#B00020',
        },
        chips: {
          // primary: 'rgba(51, 204, 204, 0.4)',
          // secondary: 'rgba(236, 164, 0, 0.4)',
          // 'primary-dark': 'rgba(51, 204, 204, 0.6)',
          // 'secondary-dark': 'rgba(236, 164, 0, 0.6)',

          'original-primary': 'rgba(51, 204, 204, 0.4)',
          'original-secondary': 'rgba(236, 164, 0, 0.4)',
          'original-primary-dark': 'rgba(51, 204, 204, 0.6)',
          'original-secondary-dark': 'rgba(236, 164, 0, 0.6)',

          primary: 'rgb(var(--color-primary) / 0.4)',
          secondary: 'rgb(var(--color-secondary) / 0.4)',
          tertiary: 'rgba(188, 80, 144, 0.4)',
          'primary-dark': 'rgb(var(--color-primary) / 0.6)',
          'secondary-dark': 'rgb(var(--color-secondary) / 0.6)',
          'tertiary-dark': 'rgba(188, 80, 144, 0.6)',

          tomato: 'rgba(255, 44, 44, 0.6)',
          mulberry: 'rgba(188, 80, 144, 0.6)',
          gray: 'rgba(0, 0, 0, 0.3)',
          'light-coral': 'rgba(207, 102, 121, 0.6)',

          'steel-blue': 'rgba(70, 130, 180, 0.6)',
          'sea-green': 'rgba(75, 170, 112, 0.6)',
          amber: 'rgba(255, 191, 0, 0.6)',
          'royal-blue': 'rgba(65, 105, 225, 0.6)',
          'kelly-green': 'rgba(47, 200, 22, 0.6)',
        },
        tomato: {
          DEFAULT: '#FF6361',
        },
        ripple: {
          DEFAULT: 'rgba(255, 255, 255, 0.7)',
        },
        text: {
          primary: 'rgba(0, 0, 0, 0.87)',
          secondary: 'rgba(0, 0, 0, 0.6)',
          disabled: 'rgba(0, 0, 0, 0.38)',
          hyperlink: '#55ADFF',
        },
        'image-background': '#d1d5db',
      },
      gridTemplateColumns: {
        'feed-body': 'calc(37% - 0.5rem) 63%',
      },
      keyframes: {
        ripple: {
          to: {
            transform: 'scale(4)',
            opacity: 0,
          },
        },
        'accordion-down': {
          from: { height: 0 },
          to: { height: 'var(--radix-accordion-content-height)' },
        },
        'accordion-up': {
          from: { height: 'var(--radix-accordion-content-height)' },
          to: { height: 0 },
        },
        slide: {
          '0%': { transform: 'translateX(100%)' },
          '100%': { transform: 'translateX(0%)' },
        },
      },
      animation: {
        slide: 'slide 30s ease-in-out infinite',
        ripple: 'ripple 0.6s linear',
        'accordion-down': 'accordion-down 0.2s ease-out',
        'accordion-up': 'accordion-up 0.2s ease-out',
      },
    },
    fontFamily: {
      poppins: ['var(--font-poppins)'],
      dmsans: ['var(--font-dm-sans)'],
    },
    fontSize: {
      base: `16px`,
      100: `100px`,
      60: `60px`,
      32: `32px`,
      28: `28px`,
      26: `26px`,
      20: `20px`,
      18: `18px`,
      16: `16px`,
      15: `15px`,
      14: `14px`,
      13: `13px`,
      12: `12px`,
      11: `11px`,
      // 'base': [`16px`, {
      //   lineHeight: '24px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '500',
      // }],
      // 'body2': [`15px`, {
      //   lineHeight: '24px',
      //   letterSpacing: '0em',
      //   fontWeight: '400',
      // }],
      // 'body1': [`15px`, {
      //   lineHeight: '20px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '400',
      // }],
      // 'subtitle2': [`16px`, {
      //   lineHeight: '21px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '400',
      // }],
      // 'subtitle1': [`18px`, {
      //   lineHeight: '23px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '400',
      // }],
      // 'button': [`16px`, {
      //   lineHeight: '24px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '500',
      // }],
      // 'chip': [`14px`, {
      //   lineHeight: '18px',
      //   letterSpacing: '0.02em',
      //   fontWeight: '400',
      // }],
      // 'caption': [`11px`, {
      //   lineHeight: '17px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '500',
      // }],
      // 'h6': [`13px`, {
      //   lineHeight: '20px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '500',
      // }],
      // 'h5': [`14px`, {
      //   lineHeight: '24px',
      //   letterSpacing: '0.02em',
      //   fontWeight: '500',
      // }],
      // 'h4': [`20px`, {
      //   lineHeight: '30px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '400',
      // }],
      // 'h3': [`20px`, {
      //   lineHeight: '30px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '500',
      // }],
      // 'h2': [`26px`, {
      //   lineHeight: '39px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '600',
      // }],
      // 'h1': [`28px`, {
      //   lineHeight: '42px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '600',
      // }],
      // 'hyperlink': [`15px`, {
      //   lineHeight: '23px',
      //   letterSpacing: '0.0015em',
      //   fontWeight: '400',
      // }],
    },
    fontWeight: {
      thin: '100',
      extralight: '200',
      light: '300',
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
      extrabold: '800',
      black: '900',
    },
    letterSpacing: {
      regular: '0.15%',
      wide: '2%',
      none: '0',
    },
  },
  plugins: [require('@tailwindcss/typography'), require('tailwindcss-animate')],
};
